// extracted by mini-css-extract-plugin
export default {"ActivitySkeleton":"investor-activity-skeleton_ActivitySkeleton__MTSVG"};